// Date formatting utilities for Malaysia timezone (Asia/Kuala_Lumpur)

const MALAYSIA_TIMEZONE = 'Asia/Kuala_Lumpur';

/**
 * Format a date to Malaysia timezone with date and time
 * @param {string|Date} date - The date to format (UTC from backend)
 * @returns {string} Formatted date string in Malaysia timezone
 */
export const formatDateTimeMY = (date) => {
  if (!date) return '-';
  
  // Append 'Z' if the date string doesn't have timezone info (assumes UTC from backend)
  const dateStr = typeof date === 'string' && !date.endsWith('Z') && !date.includes('+') 
    ? date + 'Z' 
    : date;
  
  try {
    return new Date(dateStr).toLocaleString('en-MY', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: MALAYSIA_TIMEZONE
    });
  } catch (e) {
    return '-';
  }
};

/**
 * Format a date to Malaysia timezone (date only)
 * @param {string|Date} date - The date to format (UTC from backend)
 * @returns {string} Formatted date string in Malaysia timezone
 */
export const formatDateMY = (date) => {
  if (!date) return '-';
  
  const dateStr = typeof date === 'string' && !date.endsWith('Z') && !date.includes('+') 
    ? date + 'Z' 
    : date;
  
  try {
    return new Date(dateStr).toLocaleDateString('en-MY', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      timeZone: MALAYSIA_TIMEZONE
    });
  } catch (e) {
    return '-';
  }
};

/**
 * Format a date with weekday for Malaysia timezone
 * @param {string|Date} date - The date to format (UTC from backend)
 * @returns {string} Formatted date string with weekday
 */
export const formatDateWithWeekdayMY = (date) => {
  if (!date) return '-';
  
  const dateStr = typeof date === 'string' && !date.endsWith('Z') && !date.includes('+') 
    ? date + 'Z' 
    : date;
  
  try {
    return new Date(dateStr).toLocaleDateString('en-MY', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      timeZone: MALAYSIA_TIMEZONE
    });
  } catch (e) {
    return '-';
  }
};

export default {
  formatDateTimeMY,
  formatDateMY,
  formatDateWithWeekdayMY
};
